<template>
  <div id="excursion-confirmation">
    <div
      v-if="
        (excursionChecklistEnforcementBeforeSubmissionEnabled && !getAllChecklistTicked()) ||
        highRiskChecklistsNumbersMessageDisplayed
      "
    >
      <div class="excursion-high-risk-checklists-alert alert-warning">
        <div
          v-if="excursionChecklistEnforcementBeforeSubmissionEnabled && !getAllChecklistTicked()"
        >
          {{ excursionChecklistEnforcementBeforeSubmissionMessage }}
        </div>
        <div
          v-if="
            highRiskChecklistsNumbersMessageDisplayed &&
            excursionChecklistEnforcementBeforeSubmissionEnabled &&
            !getAllChecklistTicked()
          "
          class="excursion-high-risk-checklists-message"
        >
          {{ highRiskChecklistsEnforcementNumbersBeforeSubmissionMessage }}
        </div>
        <div
          v-if="
            highRiskChecklistsNumbersMessageDisplayed &&
            (!excursionChecklistEnforcementBeforeSubmissionEnabled || getAllChecklistTicked())
          "
          class="excursion-high-risk-checklists-message"
        >
          {{ highRiskChecklistsNumbersBeforeSubmissionMessage }}
        </div>
      </div>
      <div class="arrow-div-outer">
        <div class="arrow-div-inner"></div>
      </div>
    </div>
    <v-row no-gutters>
      <v-col cols="auto">
        <v-checkbox
          id="excursion-confirmation--agreement-checkbox"
          v-model="agreementConfirmationTicked"
          color="primary"
          :disabled="
            disabledCheckbox ||
            (excursionChecklistEnforcementBeforeSubmissionEnabled && !getAllChecklistTicked()) ||
            highRiskChecklistsNumbersMessageDisplayed
          "
        >
        </v-checkbox>
      </v-col>
      <v-col>
        <v-card color="secondary">
          <v-card-text
            id="excursion-confirmation--agreement-checkbox--label"
            @click="
              !(
                disabledCheckbox ||
                (excursionChecklistEnforcementBeforeSubmissionEnabled &&
                  !getAllChecklistTicked()) ||
                highRiskChecklistsNumbersMessageDisplayed
              )
                ? (agreementConfirmationTicked = !agreementConfirmationTicked)
                : ''
            "
          >
            <span>{{ statement1 }};</span><br /><br />
            <span>and</span><br /><br />
            <span>{{ statement2 }}.</span>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import * as types from '@/store/mutationTypes';
import excursionConfirmation from '../lib/content/excursionConfirmation';

export default {
  props: {
    disabledCheckbox: Boolean
  },

  emits: ['setAgreementConfirmationManuallyTicked'],

  data() {
    return {
      statement1: '',
      statement2: '',
      excursionChecklistEnforcementBeforeSubmissionMessage: '',
      highRiskChecklistsNumbersBeforeSubmissionMessage: '',
      highRiskChecklistsEnforcementNumbersBeforeSubmissionMessage: ''
    };
  },
  computed: {
    agreementConfirmationTicked: {
      get() {
        if (!this.$store.state.common.excursionDc.agreementConfirmation) {
          return false;
        }

        // [SES-412] if ticked value is true, then agreementConfirmationTicked will be set to true
        if (
          this.$store.state.common.excursionDc.agreementConfirmation &&
          this.$store.state.common.excursionDc.agreementConfirmation.ticked
        ) {
          return true;
        }

        return this.$store.state.common.excursionDc.agreementConfirmation.ticked;
      },
      set(value) {
        const confirmInfo = {
          ticked: value,
          statement1: this.statement1,
          statement2: this.statement2
        };
        this.$emit('setAgreementConfirmationManuallyTicked', true);
        this.$store.commit(types.COMMON_SET_EXCURSION_CONFIRMATION, confirmInfo);
      }
    },
    excursionChecklistEnforcementBeforeSubmissionEnabled() {
      return this.$store.state.common.excursionChecklistEnforcementBeforeSubmissionEnabled;
    },
    highRiskChecklistsNumbersMessageDisplayed() {
      return (
        this.$store.state.common.excursionHighRiskStudentMedicalEnabled &&
        (!this.$store.state.common.excursionDc.staffSupervisorAttendanceCount ||
          !this.$store.state.common.excursionDc.studentAttendanceCount)
      );
    }
  },
  mounted() {
    const confirmation = this.$store.state.common.excursionDc.agreementConfirmation;
    if (confirmation && confirmation.statement1 && confirmation.statement2) {
      this.statement1 = confirmation.statement1;
      this.statement2 = confirmation.statement2;
    } else {
      this.statement1 = excursionConfirmation.statement1;
      this.statement2 = excursionConfirmation.statement2;
    }
    this.excursionChecklistEnforcementBeforeSubmissionMessage =
      excursionConfirmation.excursionChecklistEnforcementBeforeSubmissionMessage;
    this.highRiskChecklistsNumbersBeforeSubmissionMessage =
      excursionConfirmation.highRiskChecklistsNumbersBeforeSubmissionMessage;
    this.highRiskChecklistsEnforcementNumbersBeforeSubmissionMessage =
      excursionConfirmation.highRiskChecklistsEnforcementNumbersBeforeSubmissionMessage;
  },
  methods: {
    getAllChecklistTicked() {
      const mandatoryChecklistString = JSON.stringify(
        this.$store.state.common.excursionDc.mandatoryChecklist
      );
      const categoriesString = JSON.stringify(this.$store.state.common.excursionDc.categories);

      const checklistString = mandatoryChecklistString + categoriesString;

      const checkboxCount = (checklistString.match(/"contentType":"checkbox"/g) || []).length;
      const tickedCheckboxCount = (checklistString.match(/"ticked":true/g) || []).length;
      const allTicked = checkboxCount === tickedCheckboxCount;

      if (!allTicked && this.agreementConfirmationTicked) {
        this.agreementConfirmationTicked = false;
      }

      return allTicked;
    }
  }
};
</script>
<style scoped>
#excursion-confirmation {
  margin-bottom: 16px;
}

#excursion-confirmation .v-input--selection-controls {
  margin-top: unset;
}

#excursion-confirmation .v-card {
  box-shadow: none;
  background-color: #fafafa;
  font-style: italic;
  margin-left: 20px;
  margin-right: 8px;
}

#excursion-confirmation .arrow-div-outer {
  border-width: 19px 14px 0 !important;
  border: solid;
  border-color: rgb(var(--v-theme-primary)) transparent transparent;
  position: relative;
  margin: 0px 0 0 2px;
  width: 28px;
}

#excursion-confirmation .arrow-div-inner {
  border-width: 18px 13px 0 !important;
  border: solid;
  border-color: #ffffff transparent transparent;
  position: relative;
  margin: -20px 0 0 -13px;
}

.excursion-high-risk-checklists-message {
  margin-top: 0px;
}
.alert-warning {
  margin-top: 15px;
  color: rgb(var(--v-theme-primary));
}

.excursion-high-risk-checklists-alert {
  border: 1px solid rgb(var(--v-theme-primary));
  border-radius: 4px;
  color: rgb(var(--v-theme-primary));
  padding: 16px;
  background-color: #ffe4e6;
}
</style>
